import { api, ApiError, type Role, type User } from '../api.ts';
import { confirmDialog, el, field, select, toast } from '../ui.ts';

export async function usersView(me: User): Promise<HTMLElement> {
  const users = await api.users();
  const email = el('input', { type: 'email', placeholder: 'email' });
  const name = el('input', { type: 'text', placeholder: 'name' });
  const role = select([{ value: 'editor', label: 'editor' }, { value: 'admin', label: 'admin' }], 'editor');
  const password = el('input', { type: 'password', placeholder: '8+ characters', autocomplete: 'new-password' });
  const list = el('tbody', {}, users.map((u) => el('tr', {},
    el('td', {}, u.email), el('td', {}, u.name), el('td', {}, u.role),
    el('td', {}, u.id !== me.id && el('button', { type: 'button', class: 'danger', onClick: async () => {
      if (!confirmDialog(`Remove ${u.email}?`)) return;
      await api.deleteUser(u.id); location.reload();
    } }, 'Remove')),
  )));
  return el('section', {},
    el('div', { class: 'head' }, el('h1', {}, 'Users')),
    el('table', {}, el('thead', {}, el('tr', {}, ['Email', 'Name', 'Role', ''].map((h) => el('th', {}, h)))), list),
    el('h2', {}, 'Add user'),
    el('div', { class: 'frow' }, field('Email', email), field('Name', name), field('Role', role), field('Password', password)),
    el('button', { type: 'button', class: 'primary', onClick: async () => {
      try { await api.createUser({ email: email.value, name: name.value, role: role.value as Role, password: password.value }); toast('User added'); location.reload(); }
      catch (e) { toast(e instanceof ApiError ? e.message : 'failed', 'error'); }
    } }, 'Add'),
  );
}
